import { SalesResponse } from "@/pages/[others]/pages/sales/models/sale.interface";
import { useSaleStore } from "@/store/sale.store";

/** Clave estable para fusionar la misma venta en listados (API + local). */
export function getSaleListDedupKey(sale: SalesResponse): string {
  if (sale.offline_uuid) return `off-${sale.offline_uuid}`;
  if (sale.uuid) return `uuid-${sale.uuid}`;
  if (typeof sale.id === "number" && sale.id > 0) return `id-${sale.id}`;
  const correlative = sale.bills?.[0]?.correlative ?? 0;
  return `tmp-${sale.creation_date}-${correlative}`;
}

function saleListRank(sale: SalesResponse): number {
  const id = typeof sale.id === "number" && sale.id > 0 ? sale.id : 0;
  return (sale.synced ? 1_000_000_000 : 0) + id;
}

/** Conserva una fila por clave; prioriza sincronizada y mayor id de servidor. */
export function dedupeSalesForList(sales: SalesResponse[]): SalesResponse[] {
  const byKey = new Map<string, SalesResponse>();

  for (const sale of sales) {
    const key = getSaleListDedupKey(sale);
    const existing = byKey.get(key);
    if (!existing || saleListRank(sale) > saleListRank(existing)) {
      byKey.set(key, sale);
    }
  }

  return Array.from(byKey.values());
}

export function isOfflineUuidSyncedInStore(offlineUuid: string): boolean {
  const { allLocalSales } = useSaleStore.getState();
  return allLocalSales.sales.some(
    (sale) =>
      sale.offline_uuid === offlineUuid &&
      sale.synced === true &&
      typeof sale.id === "number" &&
      sale.id > 0
  );
}
